export default "__VITE_ASSET__BUpWYAA2__"